import { Pipe, PipeTransform } from '@angular/core';
import { WorkProspectStatusEnum } from '@work-frontend-monorepo/work-rest-api';
import { LabelVariant } from '@work-frontend-monorepo/work-ui/layout';

@Pipe({
  name: 'prospectStatusBadge',
  standalone: true,
})
export class ProspectStatusBadgePipe implements PipeTransform {
  transform(status: WorkProspectStatusEnum | null | undefined): { text: string; variant: LabelVariant } {
    switch (status) {
      case WorkProspectStatusEnum.Converted:
        return { text: 'AKQUISEOBJEKT_STATUS_UMGEWANDELT', variant: 'success' };
      case WorkProspectStatusEnum.Discarded:
        return { text: 'AKQUISEOBJEKT_STATUS_VERWORFEN', variant: 'neutral' };
      default:
        return { text: 'AKQUISEOBJEKT_STATUS_OFFEN', variant: 'warning' };
    }
  }
}
